import { Dropdown, IDropdownOption } from "office-ui-fabric-react";
import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { DecodeDateRange, getLocalAuthorityOptions, getRegionalPartnershipOptions, getSchoolOptions, getSchoolTypeOptions } from "../../../decode-filters";
import { WsDecodeContext } from "../DecodeContext";

import moment from 'moment-timezone';

import { DatePickerInput } from '@mantine/dates';



/*
use CountUp for metrics
.ws-deliver-decode-score-bar-title-ratio
*/





type WsDecodeFiltersProps = {
  defaultValues: {
    // DateRange?: string;
    regionalPartnershipId?: string;
    localAuthorityId?: string;
    schoolTypeId?: string;
    schoolId?: string;
  }
  visible: {
    DateRange?: boolean;
    RegionalPartnership?: boolean;
    LocalAuthority?: boolean;
    SchoolType?: boolean;
    School?: boolean;
  }
};




const WsDecodeFilters = (props: WsDecodeFiltersProps) => {

  const decodeContext = useContext(WsDecodeContext);



  const [ dateRangeValue, setDateRange ] = useState<[ Date | null, Date | null]>(decodeContext?.selectedDateRange ? [ decodeContext.selectedDateRange.start, decodeContext.selectedDateRange.end ] : [ null, null ]);




  useEffect(() => {

    if (props.defaultValues.regionalPartnershipId || props.defaultValues.regionalPartnershipId === '') {
      decodeContext?.setSelectedRegionalPartnershipId(props.defaultValues.regionalPartnershipId);
    }

  }, [ props.defaultValues.regionalPartnershipId ]);



  useEffect(() => {

    if (props.defaultValues.localAuthorityId || props.defaultValues.localAuthorityId === '') {
      decodeContext?.setSelectedLocalAuthorityId(props.defaultValues.localAuthorityId);
    }

  }, [ props.defaultValues.localAuthorityId ]);



  useEffect(() => {

    if (props.defaultValues.schoolTypeId || props.defaultValues.schoolTypeId === '') {
      decodeContext?.setSelectedSchoolId(props.defaultValues.schoolTypeId);
    }

  }, [ props.defaultValues.schoolTypeId ]);



  useEffect(() => {

    if (props.defaultValues.schoolId || props.defaultValues.schoolId === '') {
      decodeContext?.setSelectedSchoolId(props.defaultValues.schoolId);
    }

  }, [ props.defaultValues.schoolId ]);








  useEffect(() => {

    if (dateRangeValue && dateRangeValue[0] && dateRangeValue[1]) {
      decodeContext?.setSelectedDateRange({
        start: dateRangeValue[0],
        end:   dateRangeValue[1]
      });
    }

  }, [ dateRangeValue ]);



  return (
    <>
      <div className="ws-deliver-decode-page-filters">

        <div className="ws-deliver-decode-page-filters-column" style={{ paddingTop: '35px', paddingRight: '5px' }}>
          <b>Filter</b>
        </div>

        {
          props.visible.DateRange
          &&
          <>
            <div className="ws-deliver-decode-page-filters-column">
              <DatePickerInput
                type="range"
                label="Date Range"
                placeholder="Pick Date Range"
                value={dateRangeValue}
                onChange={setDateRange}
                mx="auto"
                maw={400}
                // monthLabelFormat="MMM YYYY"
                valueFormat="MMM D, YYYY"
              />
            </div>
          </>
        }

        {
          props.visible.RegionalPartnership
          &&
          <>
            <div className="ws-deliver-decode-page-filters-column">
              <Dropdown

                // label={`Regional Partnership`}
                label={`Zones`}

                options={getRegionalPartnershipOptions()}
                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {

                    decodeContext?.setSelectedRegionalPartnershipId(`${option.key}`);

                    decodeContext?.setSelectedLocalAuthorityId('');

                    decodeContext?.setSelectedSchoolId('');

                  }
                }}
                placeholder="Select Regional Partnership"
                selectedKey={decodeContext?.selectedRegionalPartnershipId}
                styles={{
                  dropdown: { width: 270 }
                }}
              />
            </div>
          </>
        }

        {
          props.visible.LocalAuthority
          &&
          <>

            <div className="ws-deliver-decode-page-filters-column">
              <Dropdown
                label={`Local Authority`}
                options={getLocalAuthorityOptions(decodeContext?.selectedRegionalPartnershipId || '')}
                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {

                    decodeContext?.setSelectedLocalAuthorityId(`${option.key}`);

                    decodeContext?.setSelectedSchoolId('');

                  }
                }}
                placeholder="Select Local Authority"
                selectedKey={decodeContext?.selectedLocalAuthorityId}
                styles={{
                  dropdown: { width: 360 }
                }}
              />
            </div>
          </>
        }

        {
          props.visible.SchoolType
          &&
          <>

            <div className="ws-deliver-decode-page-filters-column">

              <Dropdown

                // label={`School Type`}
                label={`Globally Managed Businesses (GBUs)`}

                options={getSchoolTypeOptions()}
                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {
                    decodeContext?.setSelectedSchoolTypeId(`${option.key}`);
                  }
                }}
                placeholder="Select School Type"
                selectedKey={decodeContext?.selectedSchoolTypeId}
                styles={{
                  dropdown: { width: 240 }
                }}
              />

            </div>
          </>
        }

        {
          props.visible.School
          &&
          <>
            <div className="ws-deliver-decode-page-filters-column">
              <Dropdown
                label={`School`}
                options={getSchoolOptions(decodeContext?.selectedRegionalPartnershipId || '', decodeContext?.selectedLocalAuthorityId || '')}
                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {
                    decodeContext?.setSelectedSchoolId(`${option.key}`);
                  }
                }}
                placeholder="Select School"
                selectedKey={decodeContext?.selectedSchoolId}
                styles={{
                  dropdown: { width: 350 }
                }}
              />
            </div>
          </>
        }

      </div>
    </>
  );
};




export {
  WsDecodeFilters
};
